import * as React from 'react';

import TranslationDropdown from 'bundles/composable-page-header/legacy/translation/TranslationDropdown';

type Props = {
  // If on an enterprise page, pass in bffData.chosenEnterpriseProgram.chosenEnterpriseProgram.naptimeThirdPartyOrganization.id here.
  currentThirdPartyOrgId?: string;
  // If in-course, pass in current course ID here.
  currentCourseId?: string;
  ariaLabelPrefix?: string;
  useIconButton?: boolean;
};

// Marking as legacy since we are re-wrapping the component currently used in legacy page header.
// TranslationDropdown should be evaluated and refactored to fit the composable page header framework.
const LanguageDropdownLegacyGridItem = ({
  currentThirdPartyOrgId,
  currentCourseId,
  ariaLabelPrefix,
  useIconButton,
}: Props) => {
  return (
    <TranslationDropdown
      courseId={currentCourseId}
      enterpriseOrgId={currentThirdPartyOrgId}
      wrapperElement="div"
      ariaLabelPrefix={ariaLabelPrefix}
      useIconButton={useIconButton}
    />
  );
};

export default LanguageDropdownLegacyGridItem;
